import { render } from "./TemplateTable.vue?vue&type=template&id=33b26714"
import script from "./TemplateTable.vue?vue&type=script&lang=js"
export * from "./TemplateTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__